import { commonFilter } from './filter';

export const MahjongTrendingPublicationsPoint = {
  pageName: 'MahjongSolitaire Trending Publications',
  pageId: '25109',
  pagePath: '/marketing/MahjongSolitaire/TrendingPublications',
  common: {
    source: 2,
    typeId: 'opinions_market_pc_v2',
  },
  button: {
    ...commonFilter,
  },
  card: {},
  table: {},
};

export const ArrowsTrendingPublicationsPoint = {
  pageName: 'Arrows Trending Publications',
  pageId: '25110',
  pagePath: '/marketing/Arrows/TrendingPublications',
  common: {
    source: 2,
    typeId: 'opinions_market_pc_v2',
  },
  button: {
    ...commonFilter,
  },
  card: {},
  table: {},
};

export const Merge2TrendingPublicationsPoint = {
  pageName: 'Merge-2 Trending Publications',
  pageId: '25115',
  pagePath: '/marketing/Merge2/TrendingPublications',
  common: {
    source: 2,
    typeId: 'opinions_market_pc_v2',
  },
  button: {
    ...commonFilter,
  },
  card: {},
  table: {},
};

export const Merge3TrendingPublicationsPoint = {
  pageName: 'Merge-3 Trending Publications',
  pageId: '25116',
  pagePath: '/marketing/Merge3/TrendingPublications',
  common: {
    source: 2,
    typeId: 'opinions_market_pc_v2',
  },
  button: {
    ...commonFilter,
  },
  card: {},
  table: {},
};
